import React, { useRef, useState, useEffect, useCallback } from 'react';
import ReactPlayer from 'react-player/lib';
import styled from 'styled-components';

const HEIGHT_RATIO = 9 / 16;

const VideoPlayerWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	background: #000000;
	width: 100%;
	max-width: 800px;
	height: ${props => props.videoWidth * HEIGHT_RATIO}px;
`;

interface IVideoPlayer {
	link: string;
	className?: string;
}

const VideoPlayer = ({ link, className }: IVideoPlayer): JSX.Element => {
	const videoBlockRef = useRef(null);
	const [videoWidth, setVideoWidth] = useState(0);

	const handleResize = useCallback(() => {
		const clientWidth = videoBlockRef?.current?.clientWidth;
		setVideoWidth(clientWidth);
	}, []);

	useEffect(() => {
		handleResize();
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [handleResize]);

	return (
		<VideoPlayerWrapper className={className} ref={videoBlockRef} videoWidth={videoWidth}>
			<ReactPlayer
				url={link}
				controls
				width="100%"
				height="100%"
				config={{
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					clientId: '44503cca1be605b5', // 測試用，網路上找的 https://codepen.io/amalajith/pen/pYmYOW
					playerId: 'youkuplayer',
				}}
			/>
		</VideoPlayerWrapper>
	);
};

export default VideoPlayer;
